import { filter, isStringEmpty, join, SuiteId } from '@libs/shared';
import { LOCAL_STORAGE } from '../constants';

const DELIMITER = '.';

export class StorageKeyManager {
    static genKey(...args: (string | number | undefined)[]) {
        return join(
            filter(args, (v) => {
                return !isStringEmpty(v);
            }),
            DELIMITER
        );
    }

    static getAccessTokenKey(suiteId: SuiteId) {
        return StorageKeyManager.genKey(LOCAL_STORAGE.SUITE_ACCESS_TOKEN, suiteId);
    }
}
